// ─────────────────────────────────────────────────────────────────────────────
// Pássaros nas batalhas: nem todo mapa tem. Só com tempo bom (sol, entardecer,
// nublado) e, mesmo assim, em ~metade das batalhas — sorteio estável pelo id
// do combate (não muda ao recarregar a página). O Hub sempre tem.
// ─────────────────────────────────────────────────────────────────────────────

const BIRD_WEATHER = new Set(['SUNNY', 'SUNSET', 'CLOUDY']);

export function combatHasBirds(combatId: string, weatherType: string | undefined): boolean {
  if (!BIRD_WEATHER.has(weatherType ?? 'SUNNY')) return false;
  let h = 0;
  for (let i = 0; i < combatId.length; i++) h = (h * 31 + combatId.charCodeAt(i)) >>> 0;
  return h % 2 === 0;
}
